import { useCallback } from 'react';

import { ALL_CHECKBOX_RELATED_FIELDS, CheckboxWithRelatedFields } from '@stores/settingsStore/constants';
import type { MailKeys } from '@stores/settingsStore/constants';

import type { OutputValues } from './useValueByFieldArray';

export const useShowElement = (
  checkBoxValues: Record<OutputValues, boolean | undefined | string>,
): ((key?: string) => boolean) =>
  useCallback(
    (key) => {
      if (
        !checkBoxValues.enableMail &&
        ALL_CHECKBOX_RELATED_FIELDS[CheckboxWithRelatedFields.mail].includes(`${key}` as MailKeys)
      ) {
        return false;
      }

      return true;
    },
    [checkBoxValues.enableMail],
  );
